module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Quotation Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFMain"
    },
    model: {
      value: (_vm.collapseFFMainVisible),
      callback: function($$v) {
        _vm.collapseFFMainVisible = $$v
      },
      expression: "collapseFFMainVisible"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "box-header"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table mobile-table table-bordered",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), _c('th', [_vm._v("FF Quotation No.")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Print")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableMainData), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      style: (index == 0 ? 'color:green' : 'color:red')
    }, [_c('b', [_vm._v("Quotation No. :")]), _vm._v("\n                            " + _vm._s(item1.mainFFSeries) + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Till :")]), _vm._v("\n                            " + _vm._s(item1.quotationTill == "1" ? "Handover" : "Sailing") + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity Date :")]), _vm._v("\n                            " + _vm._s(_vm._f("moment")(item1.ffvalidityDate)) + "\n                            "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item1.ffExpireStatus == 1 ? " (Expired)" : ""))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.collapseFFChildVisible == false) ? _c('b-button', {
      attrs: {
        "variant": "outline-dark",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.getMainFFId(item1.mainffId, 'FF')
        }
      }
    }, [_vm._v("Show Quote")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b', [_vm._v("Manager Approval :")]), _vm._v("\n                            " + _vm._s(item1.ffStatusManager == "0" ?
      "Pending" :
      item1.ffStatusManager == "1" ?
      "Approved" :
      "Rejected") + "\n                            "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Client Approval :")]), _vm._v("\n                            " + _vm._s(item1.ffClientStatus == "0" ?
      "Pending" :
      item1.ffClientStatus == "1" ?
      "Approved" :
      "Rejected") + "\n                            "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (item1.ffQuoteRejectCount != '0') ? _c('span', {
      staticClass: "error"
    }, [_vm._v("Note : Quote Rejected\n                              " + _vm._s(item1.ffQuoteRejectCount) + " Times By Client.")]) : _vm._e()]), _vm._v(" "), (
      index == '0' &&
      item1.ffClientStatus != '2' &&
      item1.ffClientStatus != '1'
    ) ? _c('td', [(
      item1.ffStatusManager != '1' &&
      item1.sendHODApproveFF == '1'
    ) ? _c('b', [_vm._v("Sent For Approval\n                              "), _c('br')]) : (
      item1.ffStatusManager == '1' &&
      item1.sendToEnquiryFF == '1'
    ) ? _c('b', [_vm._v("Sent to Enquiry\n                              "), _c('br')]) : _c('b', [_vm._v("N/A\n                              "), _c('br')])]) : _c('td', [_c('b', [_vm._v("\n                              " + _vm._s(item1.ffClientStatus == "2" && index == 0 ?
      "Client Rejected" :
      item1.ffClientStatus == "1" && index == 0 ?
      "Client Approved" :
      "N/A") + "\n                              "), _c('br')])]), _vm._v(" "), _c('td', [(item1.MainEnquiryQuotationFFCreated) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationFFCreated))]) : _vm._e(), _c('br'), _vm._v(" "), (item1.MainEnquiryQuotationFFUpdated) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationFFUpdated))]) : _vm._e(), _c('br'), _vm._v(" "), (item1.MainEnquiryQuotationFFApprovedBy) ? _c('span', [_vm._v(_vm._s(item1.MainEnquiryQuotationFFApprovedBy))]) : _vm._e(), _c('br'), _vm._v(" "), (
      item1.ffQuotationPdf != '' &&
      item1.ffQuotationPdf != null
    ) ? _c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item1.ffQuotationPdf)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")]), _vm._v(" "), (!_vm.isHidden) ? _c('div', [_c('date-picker', {
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "validityDate",
        "name": "validityDate",
        "not-before": _vm.min,
        "not-after": _vm.max
      },
      model: {
        value: (item1.ffvalidityDate),
        callback: function($$v) {
          _vm.$set(item1, "ffvalidityDate", $$v)
        },
        expression: "item1.ffvalidityDate"
      }
    }), _vm._v(" "), (!item1.ffvalidityDate) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.errorModal.ffvalidityDate))]) : _vm._e(), _vm._v(" "), _c('b-button', {
      staticClass: "smbutnWidth",
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "variant": "primary",
        "size": "sm",
        "id": "updateValidityDate"
      },
      on: {
        "click": function($event) {
          _vm.updateValidityDate(
            item1.ffvalidityDate,
            item1.mainffId,
            this.mainFFtableIdForFF,
            'FF',
            item1.quotationTill,
            (_vm.prevalidityDate = item1.ffvalidityDate)
          )
        }
      }
    }, [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), (item1.ffExpireStatus == 1) ? _c('b-button', {
      staticClass: "smbutnWidth",
      staticStyle: {
        "margin-top": "8px"
      },
      attrs: {
        "variant": "primary",
        "size": "sm",
        "id": "QutationValidityhide"
      },
      on: {
        "click": function($event) {
          _vm.QutationValidityhide(item1.ffvalidityDate, _vm.isHidden)
        }
      }
    }, [_vm._v("Qutation Extends")]) : _vm._e(), _vm._v(" "), _c('br'), _c('span', {
      attrs: {
        "id": "QutationValidityhide_err"
      }
    })], 1)])
  }))])])])])], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapseFFChild"
    },
    model: {
      value: (_vm.collapseFFChildVisible),
      callback: function($$v) {
        _vm.collapseFFChildVisible = $$v
      },
      expression: "collapseFFChildVisible"
    }
  }, [_c('div', [_c('b-card', {
    staticClass: "gutr"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Quotation Validity Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.mainFFtableIdForFF ? true : false,
      "formatter": _vm.capitalizeAll,
      "type": "date",
      "placeholder": "Enter Billing Start Date",
      "min": _vm.calculateMinDate(),
      "max": _vm.calculateMaxDate()
    },
    model: {
      value: (_vm.mainModal.ffvalidityDate),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "ffvalidityDate", $$v)
      },
      expression: "mainModal.ffvalidityDate"
    }
  })], 1)], 1), _vm._v(" "), (_vm.shipmentType == 1) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.shipmentType == 1) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Quotation Validity Till")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.qTillList,
      "option-value": "qV",
      "option-text": "qT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.mainModal.quotationTill),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "quotationTill", $$v)
      },
      expression: "mainModal.quotationTill"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "quoRate"
    }
  }, [_vm._v("Quotation Remarks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "quoRate",
      "name": "quoRate"
    },
    model: {
      value: (_vm.mainModal.quotation_remark),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "quotation_remark", $$v)
      },
      expression: "mainModal.quotation_remark"
    }
  })], 1)], 1), _vm._v(" "), (
    _vm.mainModal.sendHODApproveFF == '1' &&
    this.$sessionsStorage.get('userLevel') == '1'
  ) ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Manager Approval")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.mainModal.ffClientStatus == '1' ? true : false,
      "list": _vm.statusList,
      "option-value": "statusV",
      "option-text": "statusT",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.mainModal.ffStatusManager),
      callback: function($$v) {
        _vm.$set(_vm.mainModal, "ffStatusManager", $$v)
      },
      expression: "mainModal.ffStatusManager"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(
    _vm.mainModal.sendHODApproveFF == '1' &&
    this.$sessionsStorage.get('userLevel') == '1'
  ) ? _c('div', [_c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "variant": "primary",
      "size": "sm",
      "id": "addButtonLoaderM"
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('5')
      }
    }
  }, [_vm._v("Update")])], 1) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderM"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-navbar', {
    staticClass: "gutr ml-3",
    staticStyle: {
      "background": "white !important"
    },
    attrs: {
      "variant": "light",
      "type": "light"
    }
  }, [_c('b-navbar-nav', [(_vm.ffShipArry.length > 0) ? _c('div', [(
    _vm.mainModal.ffStatusManager != '1' &&
    _vm.mainModal.ffClientStatus != '1'
  ) ? _c('b-button-group', [(_vm.visibleMFF == true) ? _c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.visibleMFFFalse
    }
  }, [_vm._v("Close")]) : _c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.visibleMFFTrue
    }
  }, [_vm._v("New Entry")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(_vm.ffShipArry.length > 0) ? _c('div', [_c('b-button-group', [(
    _vm.mainModal.mainffId != '' &&
    _vm.mainModal.ffStatusManager != '1' &&
    _vm.mainModal.ffClientStatus != '1' &&
    _vm.mainModal.sendHODApproveFF != '1'
  ) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.openPop
    }
  }, [_vm._v("Send For Aproval\n                          "), _c('md-icon', {
    attrs: {
      "icon": "envelope"
    }
  }, [_vm._v("email")])], 1) : _vm._e()], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('div', [(_vm.ffShipArry.length > 0) ? _c('div', {
    staticClass: "gutr"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [(_vm.shipmentType == 1 && _vm.fclOrlcl == 'lcl') ? _c('th', [_vm._v("\n                              Co-Loader\n                            ")]) : (_vm.shipmentType == 1) ? _c('th', [_vm._v("Shipping Line")]) : _c('th', [_vm._v("Airline Name")]), _vm._v(" "), _c('th', [_vm._v("Client Approval")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ffShipArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [(_vm.shipmentType == 1 && _vm.fclOrlcl == 'lcl') ? _c('td', [_vm._v("\n                              " + _vm._s(item1.coLoaderName) + "\n                            ")]) : (_vm.shipmentType == 1) ? _c('td', [_vm._v("\n                              " + _vm._s(item1.shippingLine) + "\n                            ")]) : _c('td', [_vm._v(_vm._s(item1.airlineName))]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(item1.ffClientStatus == "" ?
      "Pending" :
      item1.ffClientStatus == "1" ?
      "Approved" :
      "-") + "\n                            ")]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": item1.ffClientStatus == '2'
      },
      on: {
        "click": function($event) {
          _vm.editShip(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('div', [_c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapseMiddle"
    },
    model: {
      value: (_vm.visibleMFF),
      callback: function($$v) {
        _vm.visibleMFF = $$v
      },
      expression: "visibleMFF"
    }
  }, [_c('div', [_c('div', [(
    _vm.ffShipArry.length < 3 || _vm.shipModal.ffShippingWiseId != ''
  ) ? _c('div', [_c('div', [_c('b-card', {
    staticClass: "gutr"
  }, [(_vm.shipModal.ffShippingWiseId != '') ? _c('md-layout', {
    staticClass: "justify-content-end",
    attrs: {
      "md-flex": "15"
    }
  }, [_c('div', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-dark",
      "disbaled": _vm.ffShipArry.length < 3 ? false : true
    },
    on: {
      "click": _vm.clearShip
    }
  }, [_vm._v("New\n                                      " + _vm._s(_vm.shipmentType == "1" ?
    " Shipping Line" :
    " Airline"))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.shipmentType == '2') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("\n                                      JobType :\n                                      "), _c('b', [_vm._v(_vm._s(_vm.enquiryArry[0].jobType))])])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.shipmentType == '1' ||
    _vm.shipmentType == 'Sea_Shipment'
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("\n                                      Note : Prefered Shipping Line\n                                      "), _c('b', [_vm._v(_vm._s(_vm.enquiryArry[0].shippingLine))])])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.shipmentType == 1 &&
    _vm.enquiryArry[0].containerInfo == 'lcl'
  ) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('label', [_vm._v("No.of Package")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "transitTime",
      "name": "transitTime"
    },
    model: {
      value: (_vm.noOfPkg),
      callback: function($$v) {
        _vm.noOfPkg = $$v
      },
      expression: "noOfPkg"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Vol.Wgt(In CBM)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "transitTime",
      "name": "transitTime"
    },
    model: {
      value: (_vm.volWgt),
      callback: function($$v) {
        _vm.volWgt = $$v
      },
      expression: "volWgt"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Gross Wgt.(In Kg)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "transitTime",
      "name": "transitTime"
    },
    model: {
      value: (_vm.grsWgt),
      callback: function($$v) {
        _vm.grsWgt = $$v
      },
      expression: "grsWgt"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Net Wgt.(In Kg)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "transitTime",
      "name": "transitTime"
    },
    model: {
      value: (_vm.netWgt),
      callback: function($$v) {
        _vm.netWgt = $$v
      },
      expression: "netWgt"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v(_vm._s(_vm.shipmentType == "1" && _vm.fclOrlcl == "lcl" ?
    " Co-Loader " :
    _vm.shipmentType == "1" ?
    "Shipping Line" :
    "Airline") + "\n                                      Name *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.shipModal.ffShippingWiseId != '',
      "list": _vm.shipmentType == '1' && _vm.fclOrlcl == 'lcl' ?
        _vm.coloaderData :
        _vm.shipmentType == '1' ?
        _vm.shippingList :
        _vm.airLineData,
      "option-value": _vm.shipmentType == '1' && _vm.fclOrlcl == 'lcl' ?
        'agntColoaderId' :
        _vm.shipmentType == '1' ?
        'shippingId' :
        'airlineId',
      "option-text": _vm.shipmentType == '1' && _vm.fclOrlcl == 'lcl' ?
        'coLoaderName' :
        _vm.shipmentType == '1' ?
        'shippingLine' :
        'airlineName',
      "placeholder": _vm.shipmentType == '1' && _vm.fclOrlcl == 'lcl' ?
        'Select Co-Loader' :
        _vm.shipmentType == '1' ?
        'Select Shipping Line' :
        'Select Airline'
    },
    model: {
      value: (_vm.shipModal.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.shipModal, "shippingId", $$v)
      },
      expression: "shipModal.shippingId"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', [_vm._v("Transit Time (No.of Days)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transitTime",
      "name": "transitTime",
      "type": "number"
    },
    model: {
      value: (_vm.shipModal.transitTime),
      callback: function($$v) {
        _vm.$set(_vm.shipModal, "transitTime", $$v)
      },
      expression: "shipModal.transitTime"
    }
  })], 1), _vm._v(" "), (_vm.ffModal.ffQId == '') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Particulars *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllLedgerList'],
      "option-value": "ledgerId",
      "option-text": "ledger",
      "placeholder": "Select Particular"
    },
    on: {
      "input": _vm.getPartiName
    },
    model: {
      value: (_vm.ffModal.ledgerId),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "ledgerId", $$v)
      },
      expression: "ffModal.ledgerId"
    }
  }), _vm._v(" "), (!_vm.ffModal.ledgerId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankffStatusError))]) : _vm._e()], 1) : _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Particulars")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.ledgerData,
      "option-value": "ledger",
      "option-text": "ledger",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffModal.ffType),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "ffType", $$v)
      },
      expression: "ffModal.ffType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.shipmentType == '1') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Container Type *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.containerTypeList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ffModal.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "containerTypeId", $$v)
      },
      expression: "ffModal.containerTypeId"
    }
  }), _vm._v(" "), (!_vm.ffModal.containerTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankConTypeError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "40"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.particularStatus),
      callback: function($$v) {
        _vm.particularStatus = $$v
      },
      expression: "particularStatus"
    }
  }, [_vm._v("Charges As Per Receipt")])], 1)], 1), _vm._v(" "), (_vm.particularStatus == '0') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "buyingRate"
    }
  }, [_vm._v("Buying Rate *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "buyingRate",
      "name": "buyingRate",
      "type": "number"
    },
    model: {
      value: (_vm.ffModal.buyingRate),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "buyingRate", $$v)
      },
      expression: "ffModal.buyingRate"
    }
  }), _vm._v(" "), (!_vm.ffModal.buyingRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankbuyinError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Selling Rate *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate",
      "type": "number"
    },
    model: {
      value: (_vm.ffModal.ffSellingRate),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "ffSellingRate", $$v)
      },
      expression: "ffModal.ffSellingRate"
    }
  }), _vm._v(" "), (!_vm.ffModal.ffSellingRate) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankSellingError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Currency *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.currencyList,
      "option-value": "currencyV",
      "option-text": "currencyT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffModal.currency),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "currency", $$v)
      },
      expression: "ffModal.currency"
    }
  }), _vm._v(" "), (!_vm.ffModal.currency) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.blankcurrencyError))]) : _vm._e()], 1), _vm._v(" "), (_vm.particularStatus == '0') ? _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Units *")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.unitList,
      "option-value": "unitId",
      "option-text": "unitName",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffModal.unit),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "unit", $$v)
      },
      expression: "ffModal.unit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "pr-2 pl-2",
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', {
    attrs: {
      "for": "transportType"
    }
  }, [_vm._v("Terms")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.termList,
      "option-value": "tV",
      "option-text": "tT",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.ffModal.terms),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "terms", $$v)
      },
      expression: "ffModal.terms"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "sellingRate"
    }
  }, [_vm._v("Special Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "sellingRate",
      "name": "sellingRate"
    },
    model: {
      value: (_vm.ffModal.line_wise_remark),
      callback: function($$v) {
        _vm.$set(_vm.ffModal, "line_wise_remark", $$v)
      },
      expression: "ffModal.line_wise_remark"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "justify-content-center mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticClass: "smbutnWidth",
    attrs: {
      "disabled": _vm.$sessionsStorage.get('designation') == 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
        false :
        _vm.mainModal.sendHODApproveFF == '1' ?
        true :
        false,
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addGenerateQuotation('2')
      }
    }
  }, [_vm._v(_vm._s(_vm.ffModal.ffQId == "" ? "Add" : "Update"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffModal.MainEnquiryQuotationFFCreated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v("\n                                        " + _vm._s(_vm.ffModal.MainEnquiryQuotationFFCreated))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [(_vm.ffModal.MainEnquiryQuotationFFUpdated) ? _c('span', {
    staticClass: "error pull-right"
  }, [_c('b', [_vm._v("\n                                        " + _vm._s(_vm.ffModal.MainEnquiryQuotationFFUpdated))])]) : _vm._e()])], 1)], 1)], 1)]) : _vm._e()])])])], 1), _vm._v(" "), (_vm.tempffTableArry.length > 0) ? _c('div', {
    staticClass: "box-body gutr"
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "ff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr no")]), _vm._v(" "), (_vm.shipmentType == 1 && _vm.fclOrlcl == 'lcl') ? _c('th', [_vm._v("\n                              Co-Loader\n                            ")]) : (_vm.shipmentType == 1) ? _c('th', [_vm._v("Shipping Line")]) : _c('th', [_vm._v("Airline Name")]), _vm._v(" "), (_vm.shipmentType == '1') ? _c('th', [_vm._v("Container Type")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Buying Rate")]), _vm._v(" "), _c('th', [_vm._v("Selling Rate")]), _vm._v(" "), _c('th', [_vm._v("Unit")]), _vm._v(" "), _c('th', [_vm._v("Special Remarks")]), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('th', [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('th', [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipModal.shippingId == '' ? _vm.tempffTableArry : _vm.ffTableArry), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (_vm.shipmentType == '1' && _vm.fclOrlcl == 'lcl') ? _c('td', [_vm._v("\n                              " + _vm._s(item1.coLoaderName) + "\n                            ")]) : (_vm.shipmentType == '1') ? _c('td', [_vm._v("\n                              " + _vm._s(item1.shippingLine) + "\n                            ")]) : _c('td', [_vm._v(_vm._s(item1.airlineName))]), _vm._v(" "), (_vm.shipmentType == '1') ? _c('td', [_vm._v("\n                              " + _vm._s(item1.containerType) + "\n                            ")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.buyingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.ffSellingRate) + " " + _vm._s(item1.currency))]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(item1.unitName ? item1.unitName : "NA") + "\n                            ")]), _vm._v(" "), _c('td', [_vm._v("\n                              " + _vm._s(item1.line_wise_remark ? item1.line_wise_remark : "NA") + "\n                            ")]), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": item1.ffClientStatus == '2'
      },
      on: {
        "click": function($event) {
          _vm.editFF(item1, index)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.shipModal.shippingId != '') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteTPT(item1)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1)], 1) : _vm._e()])
  }))])])]) : _vm._e()])], 1)], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopAlready",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "close": _vm.sendMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4be8ea16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/mainEnqQuotationFF.vue
// module id = 2604
// module chunks = 0